export default __webpack_public_path__ + "static/media/triangle-exclamation-solid.36ce9a4f.svg";